import { Asset, AssetsDebts, Debt } from "@fla/components";
import { createAction } from "@reduxjs/toolkit";

export const setAssets = createAction<Asset[]>("setAssets");
export const addAsset = createAction<Asset>("addAsset");
export const updateAsset = createAction<Asset>("updateAsset");

export const setDebts = createAction<Debt[]>("setDebts");
export const addDebt = createAction<Debt>("addDebt");
export const updateDebt = createAction<Debt>("updateDebt");

export const setAssetsDebts = createAction<
  Partial<AssetsDebts> & {
    currentStep: number;
  }
>("setAssetsDebts");

export const setAssetsDebtsStep = createAction<{ passedSteps?: number[]; currentStep?: number }>("setAssetsDebtsStep");

export const setInitialDetailsStep = createAction<{ passedSteps?: number[]; currentStep?: number }>(
  "setInitialDetailsStep"
);
